import React from 'react';
import { Upload, Search, ShoppingCart, CheckCircle2 } from 'lucide-react';
import { Card } from 'shared/components/ui/Card';
import { useTranslation } from 'react-i18next';
import './HowItWorksSection.scss';

const HowItWorksSection = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      icon: Upload,
      title: t('how_step_1_title', 'Upload Your Image'),
      description: t(
        'how_step_1_desc',
        'Drag and drop any fashion photo - from Instagram, Pinterest, or your camera roll. Our AI accepts all image formats.',
      ),
    },
    {
      number: '02',
      icon: Search,
      title: t('how_step_2_title', 'AI Finds Matches'),
      description: t(
        'how_step_2_desc',
        'Advanced computer vision analyzes your image, identifying items, colors, patterns, and styles to find perfect matches.',
      ),
    },
    {
      number: '03',
      icon: ShoppingCart,
      title: t('how_step_3_title', 'Compare & Shop'),
      description: t(
        'how_step_3_desc',
        'Browse similar items from thousands of stores, compare prices, and click to buy directly from verified retailers.',
      ),
    },
  ];

  return (
    <section id='how-it-works' className='how-section'>
      <div className='how-section__container'>
        <div className='how-section__header'>
          <h2 className='how-section__title'>
            {t('how_title_1', 'How It')}{' '}
            <span className='how-section__title--gradient'>{t('how_title_2', 'Works')}</span>
          </h2>
          <p className='how-section__description'>
            {t('how_description', 'Three simple steps to discover your perfect fashion pieces')}
          </p>
        </div>

        <div className='how-section__steps'>
          {/* Connecting Line */}
          <div className='how-section__connecting-line' aria-hidden='true' />

          {steps.map((step, index) => (
            <div key={index} className='how-section__step-wrapper'>
              <Card className='how-section__step-card'>
                {/* Step Number */}
                <div className='how-section__step-number'>{step.number}</div>

                {/* Icon */}
                <div className='how-section__step-icon-wrapper'>
                  <step.icon className='how-section__step-icon' aria-hidden='true' />
                </div>

                <h3 className='how-section__step-title'>{step.title}</h3>
                <p className='how-section__step-description'>{step.description}</p>
              </Card>
            </div>
          ))}
        </div>

        {/* Success Indicator */}
        <div className='how-section__success'>
          <div className='how-section__success-badge'>
            <CheckCircle2 className='how-section__success-icon' />
            <span className='how-section__success-text'>
              {t('how_success', 'Average search time: Under 30 seconds')}
            </span>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className='how-section__decoration' aria-hidden='true' />
    </section>
  );
};

export default HowItWorksSection;
